module.exports = __webpack_public_path__ + "static/img/9.4294e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/9.png
// module id = pRA0
// module chunks = 0